export const setSessionStorageItem = (item: string, itemValue: string): void => {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.setItem(item, itemValue);
  }
};

export const removeSessionStorageItem = (item: string): void => {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem(item);
  }
};

export const sessionStorageItemMatchesValue = (item: string, valueToMatch: string): boolean => {
  return getSessionStorageItem(item) === valueToMatch;
};

export const getSessionStorageItem = (item: string): string | null => {
  if (typeof sessionStorage !== 'undefined') {
    return sessionStorage.getItem(item);
  }
  return null;
};
